export const SIGILOSOS_LIST = 'SIGILOSOS_LIST';
export const SIGILOSOS_LIST_START = 'SIGILOSOS_LIST_START';
export const SIGILOSOS_LIST_SUCCESS = 'SIGILOSOS_LIST_SUCCESS';
export const SIGILOSOS_LIST_ERROR = 'SIGILOSOS_LIST_ERROR';

export const DESCLASSIFICADOS_LIST = 'DESCLASSIFICADOS_LIST';
export const DESCLASSIFICADOS_LIST_START = 'DESCLASSIFICADOS_LIST_START';
export const DESCLASSIFICADOS_LIST_SUCCESS = 'DESCLASSIFICADOS_LIST_SUCCESS';
export const DESCLASSIFICADOS_LIST_ERROR = 'DESCLASSIFICADOS_LIST_ERROR';
